import { all } from "redux-saga/effects";
import vendors from "./vendors/saga";
import locations from "./locations/saga";
import currencies from "./currencies/saga"
import prefsSaga from "./prefs/prefsSaga";
import suppliersSaga from './suppliers/saga';
import recentSearchesSaga from './recentSearches/recentSearchesSaga';
import appSaga from './app/appSaga';
import bookingSaga from './booking/saga';

function* rootSaga() {
  yield all([vendors(), locations(), currencies(), prefsSaga(), suppliersSaga(), recentSearchesSaga(), appSaga(), bookingSaga()]);
}

export default rootSaga;
